import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { prepordNewrelicConfig, pordNewrelicConfig } from './newrelic';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (window.location.host === "checkout.aqualens.in") {
  new BrowserAgent(pordNewrelicConfig);
} else if (window.location.host === "checkout-preprod.aqualens.in") {
  new BrowserAgent(prepordNewrelicConfig);
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
